// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23a1a1aa%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qr-code-page {
    min-height: calc(100vh - 68px);
    padding: 2rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background: var(--bg-primary);
}

.qr-code-container {
    max-width: 800px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.qr-code-title {
    color: var(--text-primary);
    font-size: 2rem;
    font-weight: 700;
    margin: 0;
    text-align: center;
}

.qr-code-section {
    background: var(--bg-card);
    border-radius: var(--radius);
    padding: 2rem;
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-color);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
}

.qr-code-subtitle {
    color: var(--text-primary);
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0;
}

.qr-code-image-wrapper {
    background: white;
    padding: 1rem;
    border-radius: var(--radius-sm);
    box-shadow: var(--shadow-card);
    display: flex;
    justify-content: center;
    align-items: center;
}

.qr-code-image {
    max-width: 300px;
    width: 100%;
    height: auto;
    display: block;
}

.qr-code-description {
    color: var(--text-secondary);
    font-size: 0.95rem;
    text-align: center;
    margin: 0;
}

.qr-code-hint {
    color: var(--accent-light);
    font-size: 0.9rem;
    text-align: center;
    margin: 0;
    font-weight: 500;
    padding: 0.75rem 1rem;
    background: var(--bg-secondary);
    border-radius: var(--radius-sm);
    border: 1px solid var(--border-subtle);
}

.months-section {
    background: var(--bg-card);
    border-radius: var(--radius);
    padding: 2rem;
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-color);
}

.payment-total-section {
    background: var(--bg-card);
    border-radius: var(--radius);
    padding: 2rem;
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-color);
    border-left: 4px solid var(--accent);
}

.payment-total-breakdown {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: 0.75rem;
}

.payment-total-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
    color: var(--text-secondary);
    font-size: 0.95rem;
}

.payment-total-row strong {
    color: var(--text-primary);
    font-weight: 600;
    white-space: nowrap;
}

.payment-total-note {
    margin: 0;
    font-size: 0.85rem;
    line-height: 1.4;
    color: var(--text-muted);
}

.payment-total-note-warn {
    color: var(--accent-light);
}

.payment-total-grand {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.25rem;
    padding-top: 1.25rem;
    border-top: 2px solid var(--border-subtle);
    font-size: 1.15rem;
    color: var(--text-primary);
}

.payment-total-grand strong {
    font-size: 1.35rem;
    font-weight: 700;
    color: var(--accent-light);
}

.payment-total-unavailable {
    margin: 0.5rem 0 0;
    font-size: 0.95rem;
    line-height: 1.45;
    color: var(--text-secondary);
}

.additional-services-section {
    background: var(--bg-card);
    border-radius: var(--radius);
    padding: 2rem;
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-color);
}

.additional-services-list {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.additional-service-item {
    display: grid;
    grid-template-columns: 18px 1fr auto;
    align-items: center;
    gap: 0.75rem;
    padding: 0.85rem 1rem;
    border-radius: var(--radius-sm);
    background: var(--bg-secondary);
    border: 1px solid var(--border-subtle);
    cursor: pointer;
    transition: all 0.3s ease;
}

.additional-service-item:hover {
    background: var(--bg-card-hover);
    border-color: var(--accent);
}

.additional-service-item input[type="checkbox"] {
    width: 16px;
    height: 16px;
    accent-color: var(--accent);
    cursor: pointer;
}

.additional-service-label {
    color: var(--text-primary);
    font-size: 0.95rem;
    line-height: 1.3;
}

.additional-service-price {
    color: var(--text-secondary);
    font-size: 0.9rem;
    font-weight: 600;
    white-space: nowrap;
}

.additional-services-total {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid var(--border-subtle);
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.additional-services-total-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--text-primary);
    font-size: 0.95rem;
}

.additional-services-period-hint {
    margin: 0;
    font-size: 0.85rem;
    color: var(--text-muted);
}

.additional-services-textarea {
    width: 100%;
    padding: 0.875rem 1rem;
    background: var(--input-bg);
    border: 1px solid var(--input-border);
    border-radius: var(--radius-sm);
    color: var(--text-primary);
    font-size: 0.95rem;
    font-family: var(--font);
    transition: all 0.3s ease;
    resize: vertical;
    min-height: 110px;
}

.additional-services-textarea::placeholder {
    color: var(--text-muted);
}

.additional-services-textarea:hover {
    border-color: var(--accent);
    background-color: var(--bg-card-hover);
}

.additional-services-textarea:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px var(--accent-glow);
}

.months-select-wrapper {
    margin-top: 1rem;
}

.months-select {
    width: 100%;
    padding: 0.875rem 1rem;
    background: var(--input-bg);
    border: 1px solid var(--input-border);
    border-radius: var(--radius-sm);
    color: var(--text-primary);
    font-size: 1rem;
    font-family: var(--font);
    cursor: pointer;
    transition: all 0.3s ease;
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 1rem center;
    padding-right: 2.5rem;
}

.months-select:hover {
    border-color: var(--accent);
    background-color: var(--bg-card-hover);
}

.months-select:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px var(--accent-glow);
}

.months-select option {
    background: var(--bg-card);
    color: var(--text-primary);
    padding: 0.5rem;
}

.upload-section {
    background: var(--bg-card);
    border-radius: var(--radius);
    padding: 2rem;
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-color);
}

.upload-area {
    margin-top: 1rem;
}

.upload-label {
    display: block;
    cursor: pointer;
}

.upload-input {
    display: none;
}

.upload-placeholder {
    border: 2px dashed var(--border-color);
    border-radius: var(--radius);
    padding: 3rem 2rem;
    text-align: center;
    transition: all 0.3s ease;
    background: var(--bg-secondary);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
}

.upload-label:hover .upload-placeholder {
    border-color: var(--accent);
    background: var(--bg-card-hover);
}

.upload-icon {
    width: 48px;
    height: 48px;
    color: var(--text-secondary);
    transition: color 0.3s ease;
}

.upload-label:hover .upload-icon {
    color: var(--accent);
}

.upload-text {
    color: var(--text-primary);
    font-size: 1rem;
    font-weight: 500;
}

.upload-hint {
    color: var(--text-muted);
    font-size: 0.875rem;
}

.uploaded-image-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
}

.uploaded-image {
    max-width: 100%;
    max-height: 400px;
    border-radius: var(--radius-sm);
    box-shadow: var(--shadow-card);
    object-fit: contain;
}

.remove-image-btn {
    background: linear-gradient(135deg, var(--error) 0%, #dc2626 100%);
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: var(--radius-sm);
    font-size: 0.95rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);
}

.remove-image-btn:hover {
    background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
    box-shadow: 0 6px 16px rgba(239, 68, 68, 0.35);
    transform: translateY(-2px);
}

.remove-image-btn:active {
    transform: translateY(0);
}

.pay-button-section {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
}

.pay-button {
    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);
    color: white;
    border: none;
    padding: 1rem 2.5rem;
    border-radius: var(--radius-sm);
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: var(--shadow-accent);
    font-family: var(--font);
    min-width: 200px;
}

.pay-button:hover:not(:disabled) {
    background: linear-gradient(135deg, var(--accent-hover) 0%, #1d4ed8 100%);
    box-shadow: 0 6px 20px var(--accent-glow);
    transform: translateY(-2px);
}

.pay-button:active:not(:disabled) {
    transform: translateY(0);
}

.pay-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: var(--bg-card);
    color: var(--text-muted);
    box-shadow: none;
}

@media (max-width: 768px) {
    .qr-code-page {
        padding: 1rem;
    }

    .qr-code-container {
        gap: 1.5rem;
    }

    .qr-code-title {
        font-size: 1.5rem;
    }

    .qr-code-section,
    .months-section,
    .upload-section {
        padding: 1.5rem;
    }

    .qr-code-image {
        max-width: 250px;
    }

    .upload-placeholder {
        padding: 2rem 1rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/QRCode.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,+BAA+B;IAC/B,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB,+BAA+B;IAC/B,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,0CAA0C;IAC1C,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,+BAA+B;IAC/B,+BAA+B;IAC/B,sCAAsC;IACtC,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,2BAA2B;IAC3B,qCAAqC;IACrC,+BAA+B;IAC/B,0BAA0B;IAC1B,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,2BAA2B;IAC3B,qCAAqC;IACrC,+BAA+B;IAC/B,0BAA0B;IAC1B,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,yDAA0L;IAC1L,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kEAAkE;IAClE,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;IAC7D,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,+EAA+E;IAC/E,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gCAAgC;IAChC,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,yEAAyE;IACzE,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".qr-code-page {\n    min-height: calc(100vh - 68px);\n    padding: 2rem;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    background: var(--bg-primary);\n}\n\n.qr-code-container {\n    max-width: 800px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n}\n\n.qr-code-title {\n    color: var(--text-primary);\n    font-size: 2rem;\n    font-weight: 700;\n    margin: 0;\n    text-align: center;\n}\n\n.qr-code-section {\n    background: var(--bg-card);\n    border-radius: var(--radius);\n    padding: 2rem;\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border-color);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.5rem;\n}\n\n.qr-code-subtitle {\n    color: var(--text-primary);\n    font-size: 1.25rem;\n    font-weight: 600;\n    margin: 0;\n}\n\n.qr-code-image-wrapper {\n    background: white;\n    padding: 1rem;\n    border-radius: var(--radius-sm);\n    box-shadow: var(--shadow-card);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.qr-code-image {\n    max-width: 300px;\n    width: 100%;\n    height: auto;\n    display: block;\n}\n\n.qr-code-description {\n    color: var(--text-secondary);\n    font-size: 0.95rem;\n    text-align: center;\n    margin: 0;\n}\n\n.qr-code-hint {\n    color: var(--accent-light);\n    font-size: 0.9rem;\n    text-align: center;\n    margin: 0;\n    font-weight: 500;\n    padding: 0.75rem 1rem;\n    background: var(--bg-secondary);\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border-subtle);\n}\n\n.months-section {\n    background: var(--bg-card);\n    border-radius: var(--radius);\n    padding: 2rem;\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border-color);\n}\n\n.payment-total-section {\n    background: var(--bg-card);\n    border-radius: var(--radius);\n    padding: 2rem;\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border-color);\n    border-left: 4px solid var(--accent);\n}\n\n.payment-total-breakdown {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    margin-top: 0.75rem;\n}\n\n.payment-total-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 1rem;\n    color: var(--text-secondary);\n    font-size: 0.95rem;\n}\n\n.payment-total-row strong {\n    color: var(--text-primary);\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.payment-total-note {\n    margin: 0;\n    font-size: 0.85rem;\n    line-height: 1.4;\n    color: var(--text-muted);\n}\n\n.payment-total-note-warn {\n    color: var(--accent-light);\n}\n\n.payment-total-grand {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 1.25rem;\n    padding-top: 1.25rem;\n    border-top: 2px solid var(--border-subtle);\n    font-size: 1.15rem;\n    color: var(--text-primary);\n}\n\n.payment-total-grand strong {\n    font-size: 1.35rem;\n    font-weight: 700;\n    color: var(--accent-light);\n}\n\n.payment-total-unavailable {\n    margin: 0.5rem 0 0;\n    font-size: 0.95rem;\n    line-height: 1.45;\n    color: var(--text-secondary);\n}\n\n.additional-services-section {\n    background: var(--bg-card);\n    border-radius: var(--radius);\n    padding: 2rem;\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border-color);\n}\n\n.additional-services-list {\n    margin-top: 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.additional-service-item {\n    display: grid;\n    grid-template-columns: 18px 1fr auto;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.85rem 1rem;\n    border-radius: var(--radius-sm);\n    background: var(--bg-secondary);\n    border: 1px solid var(--border-subtle);\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.additional-service-item:hover {\n    background: var(--bg-card-hover);\n    border-color: var(--accent);\n}\n\n.additional-service-item input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    accent-color: var(--accent);\n    cursor: pointer;\n}\n\n.additional-service-label {\n    color: var(--text-primary);\n    font-size: 0.95rem;\n    line-height: 1.3;\n}\n\n.additional-service-price {\n    color: var(--text-secondary);\n    font-size: 0.9rem;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.additional-services-total {\n    margin-top: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid var(--border-subtle);\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.additional-services-total-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: var(--text-primary);\n    font-size: 0.95rem;\n}\n\n.additional-services-period-hint {\n    margin: 0;\n    font-size: 0.85rem;\n    color: var(--text-muted);\n}\n\n.additional-services-textarea {\n    width: 100%;\n    padding: 0.875rem 1rem;\n    background: var(--input-bg);\n    border: 1px solid var(--input-border);\n    border-radius: var(--radius-sm);\n    color: var(--text-primary);\n    font-size: 0.95rem;\n    font-family: var(--font);\n    transition: all 0.3s ease;\n    resize: vertical;\n    min-height: 110px;\n}\n\n.additional-services-textarea::placeholder {\n    color: var(--text-muted);\n}\n\n.additional-services-textarea:hover {\n    border-color: var(--accent);\n    background-color: var(--bg-card-hover);\n}\n\n.additional-services-textarea:focus {\n    outline: none;\n    border-color: var(--accent);\n    box-shadow: 0 0 0 3px var(--accent-glow);\n}\n\n.months-select-wrapper {\n    margin-top: 1rem;\n}\n\n.months-select {\n    width: 100%;\n    padding: 0.875rem 1rem;\n    background: var(--input-bg);\n    border: 1px solid var(--input-border);\n    border-radius: var(--radius-sm);\n    color: var(--text-primary);\n    font-size: 1rem;\n    font-family: var(--font);\n    cursor: pointer;\n    transition: all 0.3s ease;\n    appearance: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23a1a1aa' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 1rem center;\n    padding-right: 2.5rem;\n}\n\n.months-select:hover {\n    border-color: var(--accent);\n    background-color: var(--bg-card-hover);\n}\n\n.months-select:focus {\n    outline: none;\n    border-color: var(--accent);\n    box-shadow: 0 0 0 3px var(--accent-glow);\n}\n\n.months-select option {\n    background: var(--bg-card);\n    color: var(--text-primary);\n    padding: 0.5rem;\n}\n\n.upload-section {\n    background: var(--bg-card);\n    border-radius: var(--radius);\n    padding: 2rem;\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border-color);\n}\n\n.upload-area {\n    margin-top: 1rem;\n}\n\n.upload-label {\n    display: block;\n    cursor: pointer;\n}\n\n.upload-input {\n    display: none;\n}\n\n.upload-placeholder {\n    border: 2px dashed var(--border-color);\n    border-radius: var(--radius);\n    padding: 3rem 2rem;\n    text-align: center;\n    transition: all 0.3s ease;\n    background: var(--bg-secondary);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n}\n\n.upload-label:hover .upload-placeholder {\n    border-color: var(--accent);\n    background: var(--bg-card-hover);\n}\n\n.upload-icon {\n    width: 48px;\n    height: 48px;\n    color: var(--text-secondary);\n    transition: color 0.3s ease;\n}\n\n.upload-label:hover .upload-icon {\n    color: var(--accent);\n}\n\n.upload-text {\n    color: var(--text-primary);\n    font-size: 1rem;\n    font-weight: 500;\n}\n\n.upload-hint {\n    color: var(--text-muted);\n    font-size: 0.875rem;\n}\n\n.uploaded-image-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    align-items: center;\n}\n\n.uploaded-image {\n    max-width: 100%;\n    max-height: 400px;\n    border-radius: var(--radius-sm);\n    box-shadow: var(--shadow-card);\n    object-fit: contain;\n}\n\n.remove-image-btn {\n    background: linear-gradient(135deg, var(--error) 0%, #dc2626 100%);\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: var(--radius-sm);\n    font-size: 0.95rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);\n}\n\n.remove-image-btn:hover {\n    background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n    box-shadow: 0 6px 16px rgba(239, 68, 68, 0.35);\n    transform: translateY(-2px);\n}\n\n.remove-image-btn:active {\n    transform: translateY(0);\n}\n\n.pay-button-section {\n    display: flex;\n    justify-content: center;\n    margin-top: 1rem;\n}\n\n.pay-button {\n    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);\n    color: white;\n    border: none;\n    padding: 1rem 2.5rem;\n    border-radius: var(--radius-sm);\n    font-size: 1.1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: var(--shadow-accent);\n    font-family: var(--font);\n    min-width: 200px;\n}\n\n.pay-button:hover:not(:disabled) {\n    background: linear-gradient(135deg, var(--accent-hover) 0%, #1d4ed8 100%);\n    box-shadow: 0 6px 20px var(--accent-glow);\n    transform: translateY(-2px);\n}\n\n.pay-button:active:not(:disabled) {\n    transform: translateY(0);\n}\n\n.pay-button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    background: var(--bg-card);\n    color: var(--text-muted);\n    box-shadow: none;\n}\n\n@media (max-width: 768px) {\n    .qr-code-page {\n        padding: 1rem;\n    }\n\n    .qr-code-container {\n        gap: 1.5rem;\n    }\n\n    .qr-code-title {\n        font-size: 1.5rem;\n    }\n\n    .qr-code-section,\n    .months-section,\n    .upload-section {\n        padding: 1.5rem;\n    }\n\n    .qr-code-image {\n        max-width: 250px;\n    }\n\n    .upload-placeholder {\n        padding: 2rem 1rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
